import { DATE_FULL_FORMAT_FROM_TIME } from '../../../constants/date'
import { isUserStatusCodeInvited } from '../../../utils/user'
import { formatDate } from '../../Table'

import { UserProfileHeaderInfoItemName } from './UserProfileHeader.constants'

function getUserProfileHeaderDateValue({ date, locale, timezone }) {
  return date
    ? formatDate({
        date,
        dateFormat: DATE_FULL_FORMAT_FROM_TIME,
        locale,
        timezone,
        useTodayFormat: false,
      })
    : null
}

export function hasUserProfileHeaderRegistrationData(userData) {
  return userData?.registeredAt != null || userData?.invitedAt != null
}

export function hasUserProfileHeaderArchiveData(userData) {
  return userData?.archivedAt != null
}

export function getUserProfileHeaderRegistrationInfoItem({
  locale,
  timezone,
  userData,
}) {
  const isInvited = isUserStatusCodeInvited(userData?.status)

  const date = isInvited ? userData?.invitedAt : userData?.registeredAt

  return {
    canEdit: false,
    name: isInvited
      ? UserProfileHeaderInfoItemName.InvitedAt
      : UserProfileHeaderInfoItemName.RegisteredAt,
    title: isInvited
      ? 'UserProfile.HeaderInfoItemInvitedAtTitleKey'
      : 'UserProfile.HeaderInfoItemRegisteredAtTitleKey',
    value: getUserProfileHeaderDateValue({ date, locale, timezone }),
  }
}

export function getUserProfileHeaderArchivedAtInfoItem({
  locale,
  timezone,
  userData,
}) {
  return {
    canEdit: false,
    name: UserProfileHeaderInfoItemName.ArchivedAt,
    title: 'UserProfile.HeaderInfoItemArchivedAtTitleKey',
    value: getUserProfileHeaderDateValue({
      date: userData?.archivedAt,
      locale,
      timezone,
    }),
  }
}
